import { Card, Grid, Typography, TextField, InputAdornment, IconButton, Box, Modal } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { AppButton } from '../../../Components/AppButton';
import { useStyles } from '../styles';
import KenColors from '../../../Helpers/Themes/kenColors';
import pdfImg from '../../../Assets/pdfimg.png';
import EditIcon from '@mui/icons-material/Edit';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { getJobsResume, postJobsApply, postJobUploadResume } from '../../../Utils/apiService';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../interfaces/Contexts';
import { useNavigate } from 'react-router-dom';
import routes from '../../../Utils/routes';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloseIcon from '@mui/icons-material/Close';
import { enqueueSnackbar } from 'notistack';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ResumeCard = (props: any) => {
  const {
    state: { user },
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const userData = user as AuthUser;
  const [searchValue, setSearchValue] = useState('');
  const [resumeDataDetails, setResumeDataDetails] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState<string>('');
  const inputFileRef = useRef<HTMLInputElement>(null);
  const classes = useStyles();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState<string | null>(null);
  const [base64String, setBase64String] = useState<string | null>(null);
  const handleFileChangeDrop = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileName(file.name);
    }
  };

  const handleButtonClickDrop = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleButtonClick = () => {
    inputFileRef.current?.click();
  };
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
    console.log('Search value:', event.target.value);
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      const allowedExtensions = ['pdf', 'doc', 'docx'];
      const maxSizeInMB = 3;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

      if (allowedExtensions.includes(fileExtension || '')) {
        if (file.size <= maxSizeInBytes) {
          setSelectedFile(file);
          setError(null);

          // Convert file to base64
          const reader = new FileReader();
          reader.onload = () => {
            const base64 = reader.result as string;
            const format = base64.split(',');
            setBase64String(format[1]);
          };
          reader.onerror = (error) => {
            setError('Error reading file');
            console.error('Error converting file to base64:', error);
          };

          reader.readAsDataURL(file);
        } else {
          setError(`File size exceeds ${maxSizeInMB} MB limit.`);
          setSelectedFile(null);
        }
      } else {
        setError('Please upload a PDF or Word document.');
        setSelectedFile(null);
      }
    }
  };
  const handleSearchClick = () => {
    console.log('Search button clicked with value:', searchValue);
  };

  const applyForJob = () => {
    const payLoad: any = {
      contactId: userData.applicantId,
      base64Data: base64String,
      title: fileName,
    };
    postJobUploadResume(payLoad)
      .then((res) => {
        console.log('res', res);
        if (res?.data?.success == true) {
          navigate(routes.jobs);
          enqueueSnackbar({ message: 'Job Applied Sucessfully', variant: 'success', autoHideDuration: 1000 });
        } else if (res?.data?.success == false) {
          enqueueSnackbar({ message: res.data.message, variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        console.error(err);
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
      });
  };
  const getResumeData = () => {
    getJobsResume(userData.applicantId)
      .then((res) => {
        console.log('res68764', res);
        setResumeDataDetails(res.data.contactsWithFiles?.[0]?.files);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  useEffect(() => {
    getResumeData();
  }, []);
  const handleDownload = (title: any, pdf: any) => {
    // Replace with your Base64 encoded PDF string
    const base64Data = pdf;
    const fileName = title;

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(link.href);
  };
  return (
    <div>
      <Card
        sx={{
          mt: 1,
          boxShadow: 'none !important',
          borderRadius: 4,
          p: 3,
          height: { lg: '82.8vh', xl: '82.8vh' },
          '@media (min-width: 1280px) and (max-width: 1300px)': {
            height: '79vh !important',
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <Typography sx={{ textAlign: 'left', fontWeight: 500, fontSize: '15px', mt: 2 }}>Your resumes</Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4} sx={{ display: 'flex', justifyContent: { xs: 'start', sm: 'start', md: 'start', lg: 'end', xl: 'end' } }}>
            <TextField
              variant="outlined"
              placeholder="Search..."
              value={searchValue}
              onChange={handleSearchChange}
              fullWidth
              size="small"
              sx={{
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                },
                '& .MuiOutlinedInput-input::placeholder': {
                  fontSize: '12px',
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton onClick={handleSearchClick}>
                      <SearchIcon style={{ fontSize: '20px' }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <AppButton
              size="small"
              variant="contained"
              className={classes.postJobBtns1}
              others={{ color: KenColors.kenWhite, marginLeft: '10px', width: 200, cursor: 'pointer', borderRadius: '6px', height: '36px' }}
              onClick={handleOpen}
            >
              <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Upload resume</Typography>
            </AppButton>
          </Grid>
        </Grid>
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box sx={style}>
            <Grid container>
              <Grid item xs={6}>
                <Typography sx={{ fontWeight: 500, fontSize: '15px' }}>
                  Resume <span style={{ color: 'red' }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleClose();
                    setFileName('');
                    setSelectedFile(null);
                  }}
                />
              </Grid>
            </Grid>

            <>
              <TextField
                placeholder="DeanForester.resume"
                variant="outlined"
                sx={{ mt: 3 }}
                value={fileName}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleButtonClickDrop}>
                        <AttachFileIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
              <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChangeDrop} />
            </>
            <>
              <AppButton
                size="small"
                variant="contained"
                className={classes.postJobBtns1}
                others={{ color: '#14296B', marginTop: 20, width: '100%', border: '1px solid #14296B' }}
                background="white"
                onClick={handleButtonClick}
              >
                {selectedFile ? selectedFile.name : 'Upload Resume'}
              </AppButton>
              <input type="file" ref={inputFileRef} style={{ display: 'none' }} accept=".pdf, .doc, .docx" onChange={handleFileChange} />
              {error && (
                <Box mt={2} color="red">
                  <p>{error}</p>
                </Box>
              )}
              {selectedFile && (
                <Box mt={2}>
                  <p>Selected file: {selectedFile.name}</p>
                  <p>File size: {(selectedFile.size / 1024).toFixed(2)} KB</p>
                </Box>
              )}
            </>
            <Box sx={{ display: 'flex', justifyContent: 'end', mt: 4 }}>
              <AppButton size="small" variant="contained" className={classes.postJobBtns1} others={{ color: KenColors.kenWhite, width: '100%' }} onClick={applyForJob}>
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Submit</Typography>
              </AppButton>
            </Box>
          </Box>
        </Modal>
        <Grid
          container
          spacing={2}
          sx={{
            height: '70vh !important',
            mt: 2,
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '62vh !important',
            },
          }}
          className="scrollbar-cusgray"
        >
          {resumeDataDetails.map((val: any) => {
            console.log('vajhgjh45', val);

            return (
              <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                <Card sx={{ backgroundColor: '#F6F8FB', p: 3, boxShadow: 'none !important', borderRadius: 3 }}>
                  <Grid container>
                    <Grid item xs={3} sm={3} md={3} lg={2} xl={2}>
                      <Box sx={{ height: '24px', width: '24px' }}>
                        <img src={pdfImg} height={'100%'} width={'100%'} />
                      </Box>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={8} xl={8}>
                      <Typography
                        sx={{
                          textAlign: 'left',
                          fontWeight: 500,
                          fontSize: '15px',
                          ml: 1,
                          '@media (min-width: 1280px) and (max-width: 1300px)': {
                            fontSize: '13px !important',
                          },
                        }}
                      >
                        {val.title}
                      </Typography>
                      {/* <Typography sx={{ textAlign: 'left', fontSize: '10.5px', ml: 1, mt: 1, fontWeight: 400 }}>Last used on 6/5/2024</Typography> */}
                    </Grid>{' '}
                    {/* <Grid item xs={3} sm={3} md={3} lg={2} xl={2}>
                      <EditIcon style={{ fontSize: '18px' }} />
                    </Grid> */}
                  </Grid>
                  <hr style={{ border: '1px solid #8C8E94', marginTop: 15 }} />
                  <Grid container sx={{ mt: 2 }}>
                    <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                      <Typography
                        sx={{
                          textAlign: 'left',
                          fontWeight: 500,
                          fontSize: '15px',
                          '@media (min-width: 1280px) and (max-width: 1300px)': {
                            fontSize: '12px !important',
                          },
                        }}
                      >
                        Download resume
                      </Typography>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4} sx={{ display: 'flex', justifyContent: 'end' }}>
                      <FileDownloadOutlinedIcon style={{ fontSize: '15px', cursor: 'pointer' }} onClick={() => handleDownload(val.title, val.base64Data)} />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Card>
    </div>
  );
};

export default ResumeCard;
